import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "news-01",
    title: "《顽皮的女朋友》第二季正式开拍，原班人马悉数回归",
    summary:
      "备受期待的都市爱情剧《顽皮的女朋友》正式宣布开机第二季，林小满与陆时晏的故事将继续展开，主创团队表示会带来更多惊喜。",
    content: [
      "今日，人气都市爱情剧《顽皮的女朋友》官方正式宣布第二季开机。据出品方透露，第二季将延续第一季轻快幽默又温暖治愈的风格，男女主角林小满与陆时晏的感情将迎来新的考验与成长。",
      "导演陈嘉行在开机仪式上表示，第二季的剧本打磨了近一年时间，团队希望在保留原有角色魅力的同时，让故事拥有更丰富的情感层次与生活质感。主演阵容也基本保持原班人马。",
      "此外，第二季还将引入几位新角色，为原本熟悉的都市故事注入新的活力。剧集预计将于明年与观众见面，具体播出时间待定。",
    ],
    author: "影视观察编辑部",
    date: "2026-09-28",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20film%20crew%20gathered%20on%20a%20warm%20sunlit%20set%20holding%20a%20clapperboard%2C%20cheerful%20celebration%20mood%2C%20warm%20amber%20and%20red%20accents%2C%20soft%20cinematic%20lighting%2C%20film%20grain%20texture%2C%20high%20detail%20editorial%20photography&width=1200&height=700&seq=news-cover-01&orientation=landscape",
    category: "剧集动态",
  },
  {
    id: "news-02",
    title: "2026年度最受期待爱情剧盘点，哪一部是你的菜？",
    summary:
      "从都市甜宠到悬疑爱情，今年的爱情剧市场百花齐放。我们盘点了本年度最值得期待的十部爱情剧，带你提前锁定追剧清单。",
    content: [
      "爱情剧一直是观众心中的常青题材。今年，各大平台纷纷推出风格各异的爱情作品，从轻松解压的都市甜宠，到充满张力的悬疑爱情，题材更加多元。",
      "在众多作品中，《顽皮的女朋友》《心动信号》等剧凭借扎实的剧本与鲜活的人物塑造脱颖而出，成为观众热议的焦点。而一些新锐导演的实验性作品，也为这一题材带来了新的表达。",
      "本文将带你逐一梳理本年度最受期待的十部爱情剧，帮助你轻松规划接下来的追剧日程。",
    ],
    author: "追剧指南",
    date: "2026-09-20",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20still%20of%20several%20romantic%20drama%20scenes%20arranged%20in%20an%20artistic%20collage%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20soft%20cinematic%20lighting%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20style%20photography&width=1200&height=700&seq=news-cover-02&orientation=landscape",
    category: "盘点推荐",
  },
  {
    id: "news-03",
    title: "影视行业观察：短剧集为何持续占领观众注意力",
    summary:
      "节奏快、信息密度高的短剧集正在改变观众的收视习惯。本文从内容形态与观看场景出发，分析短剧集崛起的背后逻辑。",
    content: [
      "近年来，单集时长更短、节奏更紧凑的短剧集迅速走红，成为内容市场不可忽视的一股力量。观众的注意力正在被重新分配，传统长剧集也面临新的挑战。",
      "短剧集的优势在于其高信息密度与强节奏感，非常契合移动端的碎片化观看场景。同时，制作周期短、成本相对可控，也让更多新锐创作者获得机会。",
      "不过，如何在有限篇幅内完成完整的人物弧光与情感铺垫，依然是短剧集创作中需要攻克的难题。未来，长短剧集很可能并非取代关系，而是各自满足不同的观看需求。",
    ],
    author: "行业观察员",
    date: "2026-09-12",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20modern%20viewing%20room%20with%20a%20large%20screen%20glowing%20in%20amber%20light%2C%20deep%20red%20accents%2C%20soft%20cinematic%20atmosphere%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-03&orientation=landscape",
    category: "行业观察",
  },
  {
    id: "news-04",
    title: "《迷雾追凶》主创独家专访：如何打造一部不注水的悬疑剧",
    summary:
      "作为今年口碑颇佳的悬疑剧，《迷雾追凶》凭借克制的叙事和扎实的案件逻辑赢得观众认可。我们与主创聊了聊创作背后的思考。",
    content: [
      "《迷雾追凶》自开播以来，凭借冷峻的氛围与层层递进的悬念收获好评。导演 Marcus Hale 在专访中坦言，悬疑剧最大的敌人是'注水'与'套路'。",
      "为了保持剧情的紧凑与真实，编剧团队在开拍前进行了大量的案件调研，并反复推演每一个推理节点，力求让观众在跟随主角破案的过程中获得参与感。",
      "对于第二季的传闻，主创团队表示一切都在计划之中，但更希望先把这一季的故事讲完、讲好。",
    ],
    author: "深度访谈",
    date: "2026-09-05",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20portrait%20of%20a%20film%20director%20seated%20in%20a%20dim%20studio%20with%20dramatic%20deep%20red%20side%20lighting%2C%20charcoal%20tones%2C%20soft%20cinematic%20haze%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-04&orientation=landscape",
    category: "深度访谈",
  },
  {
    id: "news-05",
    title: "经典爱情电影修复版重映，重温银幕上的浪漫瞬间",
    summary:
      "多部经典爱情电影将以修复版形式重返大银幕，让新一代观众有机会在影院重新感受那些历久弥新的浪漫故事。",
    content: [
      "近日，多部经典爱情电影宣布将以数字修复版的形式重新登陆院线。这些作品跨越数十年，记录了不同时代人们对爱情的理解与表达。",
      "修复团队表示，除了画质与音效的全面升级，他们还尽可能保留了原作的时代质感，让观众既能看清每一处细节，又不失胶片特有的温度。",
      "此次重映被不少影迷视为一次难得的'时光之旅'，也让年轻观众有机会在大银幕上补上那些错过的经典。",
    ],
    author: "电影频道",
    date: "2026-08-26",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20editorial%20photograph%20of%20a%20vintage%20cinema%20interior%20with%20warm%20amber%20seat%20lights%20and%20a%20glowing%20screen%2C%20deep%20red%20curtains%2C%20soft%20cinematic%20haze%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-05&orientation=landscape",
    category: "影讯速递",
  },
  {
    id: "news-06",
    title: "新生代演员崛起：他们正在重新定义荧屏魅力",
    summary:
      "一批年轻演员正在凭借扎实的表演走进观众视野。本文聚焦这股新生力量，看看他们如何用作品说话。",
    content: [
      "在近年的影视作品中，越来越多新面孔开始担纲主角。他们大多接受过系统的表演训练，也更熟悉年轻观众的审美与表达方式。",
      "与前辈相比，这批新生代演员更愿意尝试多元题材，从现实主义到类型化作品均有涉猎。他们的表演不再只追求'好看'，而更注重角色的真实与层次。",
      "业内普遍认为，良性的新人培养机制是行业持续繁荣的关键。观众也乐见更多新鲜、有生命力的表达出现在荧屏之上。",
    ],
    author: "人物聚焦",
    date: "2026-08-15",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20editorial%20photograph%20of%20young%20actors%20posing%20together%20in%20warm%20natural%20light%2C%20amber%20and%20soft%20red%20accents%2C%20cheerful%20confident%20mood%2C%20soft%20cinematic%20lighting%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-06&orientation=landscape",
    category: "人物聚焦",
  },
  {
    id: "news-07",
    title: "科幻影视改编迎来新浪潮，文学与影像如何对话？",
    summary:
      "随着多部科幻文学作品被搬上荧幕，文学与影像之间的改编话题再次引发讨论。本文探讨科幻改编的机遇与挑战。",
    content: [
      "科幻题材近年热度持续攀升，越来越多的科幻文学作品被改编为影视剧。如何在保留原作思想内核的同时，完成从文字到影像的转化，成为创作者共同面对的课题。",
      "成功的改编往往不是简单的'复制'，而是在尊重原作精神的基础上，用影像语言重构想象世界。视觉呈现、节奏把控与情感落点，都是决定成败的关键。",
      "可以预见，随着制作技术与观众审美的同步提升，科幻改编将迎来更广阔的创作空间。",
    ],
    author: "文化评论",
    date: "2026-08-03",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20editorial%20photograph%20of%20a%20glowing%20futuristic%20city%20skyline%20at%20dusk%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20cinematic%20atmosphere%2C%20soft%20haze%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-07&orientation=landscape",
    category: "行业观察",
  },
  {
    id: "news-08",
    title: "暑期档观察：类型多元背后，观众在期待什么？",
    summary:
      "今年的暑期档类型丰富，既有主打情感的轻喜剧，也有气势宏大的灾难片。多样化的供给背后，折射出观众怎样的期待？",
    content: [
      "今年暑期档的影片类型比往年更加多元，从爱情轻喜剧到灾难动作大片，几乎覆盖了主流的观影需求。这种丰富度，被业内视为市场日趋成熟的表现。",
      "观众的选择也变得更加理性，口碑对票房的影响愈发显著。一部作品能否打动人，越来越取决于内容本身的诚意与品质。",
      "对于创作者而言，如何在类型化表达与情感共鸣之间取得平衡，或许才是赢得观众的关键。",
    ],
    author: "市场分析",
    date: "2026-07-22",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20crowded%20cinema%20lobby%20with%20glowing%20marquee%20lights%20in%20amber%20and%20red%20tones%2C%20lively%20mood%2C%20soft%20cinematic%20haze%2C%20film%20grain%20texture%2C%20high%20detail%20magazine%20photography&width=1200&height=700&seq=news-cover-08&orientation=landscape",
    category: "市场分析",
  },
];

export const getNewsById = (id: string): NewsItem | undefined =>
  newsList.find((item) => item.id === id);